// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/Create/Universe.css
// module id = 705
// module chunks = 0